var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSbp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: "25.7392mm",
    height: "31.75mm",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    viewBox: "0 0 216.15 266.63",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path66",
    className: "fil0",
    fill: "#43B02A",
    points: "-0,58.04 32.29,115.75 32.29,150.95 0.04,208.55 "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path68",
    className: "fil0",
    fill: "#43B02A",
    points: "123.98,94.75 154.23,76.2 216.15,76.15 123.98,132.61 "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path70",
    className: "fil0",
    fill: "#43B02A",
    points: "123.8,57.7 123.98,134.11 91.61,114.22 91.61,0 123.81,57.7 "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path72",
    className: "fil0",
    fill: "#43B02A",
    points: "216.15,76.15 154.23,76.2 123.8,57.7 91.61,0 216.15,76.15 "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path74",
    className: "fil0",
    fill: "#43B02A",
    points: "123.98,208.87 123.98,171.8 91.61,152.29 91.63,266.63 "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path76",
    className: "fil0",
    fill: "#43B02A",
    points: "154.16,190.5 32.29,115.75 -0,58.04 216.02,190.42 154.15,190.5 "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path78",
    className: "fil0",
    fill: "#43B02A",
    points: "91.63,266.63 123.97,208.87 154.15,190.5 216.02,190.42 "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path80",
    className: "fil0",
    fill: "#43B02A",
    points: "0.04,208.55 91.88,152.3 61,133.35 32.29,150.95 "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSbp);
export default __webpack_public_path__ + "static/media/sbp.700f410811df852a8a61c054da5846e3.svg";
export { ForwardRef as ReactComponent };